const { mergeMap } = require("rxjs/operators");
const { ofType } = require("redux-observable");

const {
  marketCustomerCatalogue: customerApi,
} = require("@doctoroncallcom/api/marketplace");
const {
  GET_PRODUCTS_LIST_WITH_FILTERS,
  GET_PRODUCTS_LIST_WITHOUT_FILTERS,
  GET_PRODUCTS_LIST_WITH_SEARCH,
  GET_NEW_PRODUCT,
  GET_FEATURED_PRODUCT,
  GET_PARTICULAR_PRODUCTS,
  GET_STORE_DETAILS,
  GET_STORE_PRODUCT_LIST,
  GET_STORE_FEATURED_PRODUCT_LIST,
  GET_PRODUCT_CATEGORY,
} = require("./constants");
const {
  getProductsListWithFiltersSuccess,
  getProductsListWithFiltersError,

  getProductsListWithoutFiltersSuccess,
  getProductsListWithoutFiltersError,

  getProductsListWithSearchSuccess,
  getProductsListWithSearchError,

  getNewProductsSuccess,
  getNewProductsError,

  getFeaturedProductsSuccess,
  getFeaturedProductsError,

  getParticularProductsSuccess,
  getParticularProductsError,

  getStoreDetailsSuccess,
  getStoreDetailsError,

  getStoreProductsSuccess,
  getStoreProductsError,

  getStoreFeaturedProductsSuccess,
  getStoreFeaturedProductsError,

  getProductCategoryError,
  getProductCategorySuccess,
} = require("./actions");

const getProductsListWithFilters = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PRODUCTS_LIST_WITH_FILTERS),
    mergeMap((action) =>
      customerApi
        .productsList(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          _search: action.payload.search,
          filters: action.payload.filters,
        })
        .then((response) => getProductsListWithFiltersSuccess(response.data))
        .catch((error) => getProductsListWithFiltersError(error))
    )
  );

const getProductCategory = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PRODUCT_CATEGORY),
    mergeMap((action) =>
      customerApi
        .productCategory(marketplace, {
          mode: 1,
          _page: action.payload.size,
          _pagesize: action.payload.pageSize,
          filters: [
            `is_available:"true"`,
            `product_type:"Non-Poison/Consumer Goods"`,
            `product_category:"${action.payload.name}"`,
          ],
          _search: action.payload.search,

        })
        .then((response) => getProductCategorySuccess(response.data))
        .catch((error) => getProductCategoryError(error))
    )
  );

const getProductsListWithoutFilters = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PRODUCTS_LIST_WITHOUT_FILTERS),
    mergeMap((action) =>
      customerApi
        .productsList(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          _search: action.payload.pageSize,
        })
        .then((response) => getProductsListWithoutFiltersSuccess(response.data))
        .catch((error) => getProductsListWithoutFiltersError(error))
    )
  );

const getProductsListWithSearch = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PRODUCTS_LIST_WITH_SEARCH),
    mergeMap((action) =>
      customerApi
        .productsList(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          _search: action.payload.search,
        })
        .then((response) => getProductsListWithSearchSuccess(response.data))
        .catch((error) => getProductsListWithSearchError(error))
    )
  );
const getNewProducts = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_NEW_PRODUCT),
    mergeMap((action) =>
      customerApi
        .newProducts(marketplace, {
          type: action.payload.type,
        })
        .then((response) => getNewProductsSuccess(response.data))
        .catch((error) => getNewProductsError(error))
    )
  );

const getFeaturedProducts = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_FEATURED_PRODUCT),
    mergeMap((action) =>
      customerApi
        .newProducts(marketplace, {
          type: action.payload.type,
        })
        .then((response) => getFeaturedProductsSuccess(response.data))
        .catch((error) => getFeaturedProductsError(error))
    )
  );

const getParticularProducts = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_PARTICULAR_PRODUCTS),
    mergeMap((action) =>
      customerApi
        .particularProducts(marketplace, action.payload.uuid)
        .then((response) => getParticularProductsSuccess(response.data))
        .catch((error) => getParticularProductsError(error))
    )
  );

const getStoreDetails = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_STORE_DETAILS),
    mergeMap(() =>
      customerApi
        .storeDetails(marketplace)
        .then((response) => getStoreDetailsSuccess(response.data))
        .catch((error) => getStoreDetailsError(error))
    )
  );
const getStoreProducts = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_STORE_PRODUCT_LIST),
    mergeMap((action) =>
      customerApi
        .storeProductsList(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          _search: action.payload.search,
          type: action.payload.type,
          uuid: action.payload.uuid,
        })
        .then((response) => getStoreProductsSuccess(response.data))
        .catch((error) => getStoreProductsError(error))
    )
  );
const getStoreFeaturedProducts = (action$, state$, { marketplace }) =>
  action$.pipe(
    ofType(GET_STORE_FEATURED_PRODUCT_LIST),
    mergeMap((action) =>
      customerApi
        .storeProductsList(marketplace, {
          _page: action.payload.page,
          _pagesize: action.payload.pageSize,
          _search: action.payload.search,
          type: action.payload.type,
          uuid: action.payload.uuid,
        })
        .then((response) => getStoreFeaturedProductsSuccess(response.data))
        .catch((error) => getStoreFeaturedProductsError(error))
    )
  );
module.exports = {
  getProductsListWithFilters,
  getProductsListWithoutFilters,
  getProductsListWithSearch,
  getNewProducts,
  getFeaturedProducts,
  getParticularProducts,
  getStoreDetails,
  getStoreProducts,
  getStoreFeaturedProducts,
  getProductCategory,
  getProductCategory,
};
